import React from 'react';
import {
  Accordion as UiAccordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@crisp/crisp-ui/cabbage';
import { Icon } from './Icon';

export interface AccordionProps {
  title: string;
  defaultOpen?: boolean | string;
  icon?: string;
  children?: React.ReactNode;
  className?: string;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  defaultOpen = false,
  icon,
  children,
  className = '',
}) => {
  const open = defaultOpen === true || defaultOpen === 'true';

  return (
    <UiAccordion className={className} defaultValue={open ? ['item'] : []}>
      <AccordionItem value="item">
        <AccordionTrigger>
          {icon ? <Icon name={icon} /> : null}
          {title}
        </AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </UiAccordion>
  );
};

export default Accordion;
